import { useState, useEffect, useRef } from 'react';
import { useTheme } from '../../context/theme';
import { renderIcon } from '../../utils/icons';

export function BottomNav({ view, onNav, chatOpen, onChatOpen, unread, isAdmin }) {
  const { theme, isDark } = useTheme();
  const [moreOpen, setMore] = useState(false);
  const [hidden, setHidden] = useState(false);
  const lastScroll = useRef(0);
  const mainEl = useRef(null);

  useEffect(() => {
    const el = document.querySelector('.mobile-main-padded');
    if (!el) return;
    mainEl.current = el;
    const onScroll = () => {
      const y = el.scrollTop;
      if (y > lastScroll.current && y > 40) setHidden(true);
      else if (y < lastScroll.current) setHidden(false);
      lastScroll.current = y;
    };
    el.addEventListener('scroll', onScroll, { passive: true });
    return () => el.removeEventListener('scroll', onScroll);
  }, []);

  const primary = [
    { id: 'sites', icon: 'map-pin', label: 'Sites' },
    { id: 'dashboard', icon: 'layout-dashboard', label: 'Dashboard' },
    { id: 'pipeline', icon: 'target', label: 'Pipeline' },
    { id: 'calendar', icon: 'calendar', label: 'Calendar' },
    { id: 'chat', icon: 'message-circle', label: 'Chat', isChat: true },
    { id: 'more', icon: 'more-horizontal', label: 'More' },
  ];

  const moreItems = [
    { id: 'activity', icon: 'activity', label: 'Activity' },
    { id: 'documents', icon: 'folder-open', label: 'Documents' },
    { id: 'email', icon: 'mail', label: 'Email' },
    { id: 'partners', icon: 'users', label: 'Partners' },
  ];
  if (isAdmin) moreItems.push({ id: 'admin', icon: 'settings', label: 'Admin' });

  const moreIds = new Set(moreItems.map(m => m.id));
  const isActive = id => {
    if (id === 'chat') return chatOpen;
    if (id === 'more') return moreOpen || moreIds.has(view);
    return view === id && !chatOpen;
  };

  const handleTap = item => {
    if (item.isChat) { onChatOpen(); setMore(false); return; }
    if (item.id === 'more') { setMore(p => !p); return; }
    onNav(item.id); setMore(false);
  };

  const handleMore = item => { onNav(item.id); setMore(false); };

  return (
    <>
      <div className={`bottom-nav-overlay${moreOpen ? ' open' : ''}`} onClick={() => setMore(false)} />
      <div
        className={`bottom-nav-more-sheet${moreOpen ? ' open' : ''}`}
        style={{ background: theme.bgCard, borderTop: `1px solid ${theme.border}`, boxShadow: '0 -4px 20px rgba(0,0,0,0.15)' }}
      >
        {moreItems.map(m => (
          <button key={m.id} className="more-item" onClick={() => handleMore(m)} style={{ color: view === m.id && !chatOpen ? theme.accent : theme.text }}>
            <span className="more-icon">{renderIcon(m.icon, 20)}</span>
            {m.label}
          </button>
        ))}
      </div>
      <div
        className={`bottom-nav${hidden ? ' hidden' : ''}`}
        style={{ background: theme.bgCard, borderTop: `1px solid ${theme.border}`, boxShadow: '0 -2px 10px rgba(0,0,0,0.08)' }}
      >
        {primary.map(p => (
          <button
            key={p.id}
            className={`bottom-nav-item${isActive(p.id) ? ' active' : ''}`}
            onClick={() => handleTap(p)}
            style={{ color: isActive(p.id) ? theme.accent : theme.textMuted }}
          >
            <span className="bn-icon" style={{ position: 'relative' }}>
              {renderIcon(p.icon, 20)}
              {p.isChat && unread > 0 && (
                <span style={{ position: 'absolute', top: -4, right: -8, background: '#ef4444', color: '#fff', fontSize: 9, fontWeight: 700, borderRadius: 10, padding: '1px 5px', minWidth: 14, textAlign: 'center' }}>
                  {unread}
                </span>
              )}
            </span>
            <span className="bn-label">{p.label}</span>
          </button>
        ))}
      </div>
    </>
  );
}
